import React, { useState, useRef, useEffect, Fragment } from "react";
import "./../components/Report.scss";
import { _hasPermission } from "../../../../../../shared/helpers/access";
import { _axiosCall } from "../../../../../../shared/helpers/apicalls";
import moment from "moment";
import PropertyTypePage from "./../components/PropertyTypePage";
import CoverPage from "./../components/CoverPage";

import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  _replaceAbbreviations,
  _formatBed,
  _isEqual,
  _tranformTagsQuery,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  _activityFL,
} from "../../../../../../shared/helpers/utils";

import { generatePeriodNames, prepareResForAI, filterAIData, getCurrentPeriod, getPriorPeriod, getRangeEnd, getRangeStart, openAIModel, _reportGeoLabel, _reportScopePrompt} from "../../../exportreport/utils"
const apiURL = process.env.API_ROOT;

let statTypes = [
  
  {
    key: "sales",
    title: "New and Resale Co-ops",
    name: "Co-op Market Report",
    checkedColor: "#780F9E",
    activitesQuery:
      '(event_tags:(co?op* coop* condo*p) AND -address_2_normalized:"")',
    default: true,
  },
  {
    key: "studio",
    title: "Co-op Market - Studios",
    name: "Studios",
    checkedColor: "#780F9E",
    activitesQuery:
      '(event_tags:(co?op* coop* condo*p) AND -address_2_normalized:"" AND bedrooms:0)',
    default: true,
  },
  {
    key: "1bed",
    title: "Co-op Market - 1 Bedrooms",
    name: "One Bedrooms",
    checkedColor: "#780F9E",
    activitesQuery:
      '(event_tags:(co?op* coop* condo*p) AND -address_2_normalized:"" AND bedrooms:1)',
    default: true,
  },
  {
    key: "2bed",
    title: "Co-op Market - 2 Bedrooms",
    name: "Two Bedrooms",
    checkedColor: "#780F9E",
    activitesQuery:
      '(event_tags:(co?op* coop* condo*p) AND -address_2_normalized:"" AND bedrooms:2)',
    default: true,
  },
  {
    key: "3bed",
    title: "Co-op Market - 3 Bedrooms",
    name: "Three Bedrooms",
    checkedColor: "#780F9E",
    activitesQuery:
      '(event_tags:(co?op* coop* condo*p) AND -address_2_normalized:"" AND bedrooms:3)',
    default: true,
  },
  {
    key: "4bed",
    title: "Co-op Market - 4 Bedrooms",
    name: "Four+ Bedrooms",
    checkedColor: "#780F9E",
    activitesQuery:
      '(event_tags:(co?op* coop* condo*p) AND -address_2_normalized:"" AND bedrooms:[4 TO *])',
    default: true,
  },
 
];



const statFacet = {
   "med_price":"percentile(price, 50)",
   "by_borough" : {
     "type" : "terms",
     "field" : "borough",
     "facet" : {
        "med_price":"percentile(price, 50)"
     }
   },
   "ppsf":{
      "type":"query",
      "q":"sq_ft:[300 TO 20000]",
      "facet":{
         "med":"percentile(div(price, sq_ft), 50)"
      }
   },
   "dom":{
      "type":"query",
      "q":"days_on_market:[3 TO 720]",
      "facet":{
         "med":"percentile(days_on_market, 50)"
      }
   },
   "under_one":{
      "type":"query",
      "q":"price:[10000 TO 999999]"
   },
   "one_to_two":{
      "type":"query",
      "q":"price:[1000000 TO 1999999]"
   },
   "two_to_four":{
      "type":"query",
      "q":"price:[2000000 TO 3999999]"
   },
   "four_to_ten":{
      "type":"query",
      "q":"price:[4000000 TO 9999999]"
   },
   "ten_plus":{
      "type":"query",
      "q":"price:[10000000 TO 350000000]"
   }
}




const BlendedLayout = (props) => {
  const {
    fetchInProgress,
    setFetchInProgress,
    user,
    reportLoaded,
    setReportLoaded,
    reportData,
    setReportData,
    searchTags,
    summarizeGeographies,
    customDate,
    submit,
    setSubmit,
    color,
    setAiResponse,
    AiResponse,
    setFetchAi,
    fetchAi,
    setAIInProgress
  } = props;
  const { dateOptions } = customDate;
  const currentPeriod = getCurrentPeriod(dateOptions)
  const priorPeriod = getPriorPeriod(dateOptions)

  const priorYearPeriod = priorPeriod;
  const rangeEnd = getRangeEnd(dateOptions);
  const rangeStart = getRangeStart;
  const gap = dateOptions.gap;
  const currentPeriodName = generatePeriodNames(dateOptions).currentPeriod;
  const priorYearPeriodName = generatePeriodNames(dateOptions).priorYearPeriod;
  useEffect(() => {
    if (!reportData && !fetchInProgress && submit) {
      loadData();
      setSubmit(false)
    }
  }, [submit]);
  useEffect(() => {
    console.log(reportData, fetchAi)
      const fetchAIData = async () => {
       setFetchAi &&  setFetchAi(false);
       setAIInProgress(true);
       

     let  aiData = prepareResForAI(JSON.parse(JSON.stringify(reportData.facets)));
         const aiResponse = await handleAIGenerate(aiData);
      
   
        setAiResponse &&  setAiResponse(aiResponse);
        setAIInProgress(false);
      };
    
      if ( reportData && fetchAi) {
        fetchAIData();
        
      }
    }, [reportData, fetchAi])
  const dataFacet = {
  contract_signed: {
    type: "query",
    q: "topic:listings AND event_tags:contract-signed AND -event_tags:rent AND -event_tags:*commercial*",
    facet: {
    current_period: {
      type: "query",
      q: `time:${currentPeriod}`,
      facet: statFacet,
    },
    prior_year_period: {
      type: "query",
      q: `time:${priorYearPeriod}`,
      facet: statFacet,
    },
    chart: {
      range: {
      field: "time",
      start: rangeStart,
      end: rangeEnd,
      gap: gap,
      facet: {
        dom: {
        type: "query",
        q: "days_on_market:[3 TO 720]",
        facet: {
          avg: "avg(days_on_market)",
          med: "percentile(days_on_market, 50)",
        },
        },
      },
      },
    },
    },
  },
  recorded_sold: {
    type: "query",
    q: "topic:transactions AND event_tags:recorded-sale AND -event_tags:*commercial* AND  -event_tags:property-type_parking-space AND -event_tags:property-type_storage-room AND -event_tags:parcels_bulk-sale",
    facet: {
    current_period: {
      type: "query",
      q: `time:${currentPeriod}`,
      facet: statFacet,
    },
    prior_year_period: {
      type: "query",
      q: `time:${priorYearPeriod}`,
      facet: statFacet,
    },
    chart: {
      range: {
      field: "time",
      start: rangeStart,
      end: rangeEnd,
      gap: gap,
      facet: {
        med_price: "avg(price)",
        med_price: "percentile(price, 50)",
        sum_price: "sum(price)",
        ppsf: {
        type: "query",
        q: "sq_ft:[300 TO 20000]",
        facet: {
          avg: "avg(div(price, sq_ft))",
          med: "percentile(div(price, sq_ft), 50)",
        },
        },
      },
      },
    },
    },
  },
  }

  const loadData = async () => {
    let q = "*:*";
    let locQuery = _tranformTagsQuery(searchTags);

    if (locQuery) {
      q = locQuery;
    }

    const defaultQ = getCohortQuery(user, true);
    const fq = [
      ..._activityFQ.slice(),
      ...[
        `{!join from=alternate_keys fromIndex=we3-buildings to=building}${defaultQ}`,
      ],
    ];
    setFetchInProgress(true);
    let facet = {}
    statTypes.map(item => {
      facet[item.key] = {
        "type" : "query",
        "q" : item.activitesQuery,
        "facet" : dataFacet
      }
      
    })
    let axiosData = {
      url: apiURL + "/query/we3-activities-3",
      method: "post",
      query: {
        q: q,
        fq: fq,
        wt: "json",
        rows: 0,
        "json.facet": facet
      },
    };

    let res = await _axiosCall(axiosData)
      .then(async (res) => {
        let aiData;
        if (res && res.facets) {
          // aiData = prepareResForAI(JSON.parse(JSON.stringify(res.facets)));
          // const aiResponse = await handleAIGenerate(aiData);
          // res["aiResponse"] = aiResponse;
          setFetchInProgress(false);
          setReportLoaded(true);
          setSubmit(false);
          setReportData(res);
          setFetchAi && setFetchAi(true);
        }
        return res;
      })
      .catch((error) => {
        console.log("error: " + error);
      });
  };
  const handleAIGenerate = async (data) => {
    const prompt = `Given the following data give me an analysis that speaks to current period trends vs prior year periods for the co-op market, the chart contains more history.  The analysis should look at root nodes (residential_sales, condo, coop and single_family) and separately analayze  contracts_signed and recorded_sold.  The analysis should be easy to understand for consumer audiences.  For contracts_signed focus only on the count of contracts and days on market (dom), for recorded_sold ignore count and focus on prices.  The analysis should be  concise, 2 to 3 sentences.  Just text.  Abbreviate long currency so it's $1.5M, round if less than $1M.  If less than $1M use K.  Number should be in format ###,###,###  The results should be in valid raw JSON format, no formatting.  { "sales" : { contracts_signed: "analysis in text", recorded_sales: "analysis in text"}, studio : { contracts_signed: "analysis in text", recorded_sales: "analysis in text"}, 1bed: { contracts_signed: "analysis in text", recorded_sales: "analysis in text"}, 2bed: { contracts_signed: "analysis in text", recorded_sales: "analysis in text"}, 3bed: { contracts_signed: "analysis in text", recorded_sales: "analysis in text"}, 4bed: { contracts_signed: "analysis in text", recorded_sales: "analysis in text"} }
    
    The report contains the following key stats:${JSON.stringify(filterAIData(data))}
    
    GEOGRAPHY: ${_reportGeoLabel(searchTags, summarizeGeographies)}. ${_reportScopePrompt(searchTags, summarizeGeographies)}
    
    Current Period: ${currentPeriodName}
    Prior Year Period: ${priorYearPeriodName}`;

    const queryData = {
      messages: [
        {
          role: "system",
          content: `You are a NYC real estate expert that provides insightly data-driven analysis that are easy to understand.  You speak in a professional yet friendly manner.  Think TV or news analysts.`,
        },
        { role: "user", content: prompt },
      ],
      model: openAIModel,
      response_format: { type: "json_object" },
    };

    const axiosData = {
      url: apiURL + "/ai/chat",
      method: "post",
      query: queryData,
    };
    let aiResponse = {};
    try {
      const res = await _axiosCall(axiosData);
      console.log(res);

      if (
        res &&
        res.choices &&
        res.choices[0] &&
        res.choices[0].message &&
        res.choices[0].message.content
      ) {
        const result = res.choices[0].message.content;
        
        try {
          aiResponse = JSON.parse(result);
          console.log(aiResponse);
        } catch (e) {}
      }
    } catch (error) {
      console.log("Error generating summary:", error);
    }
    return aiResponse;
  };
  
  const percentageChange = (
    newValue,
    oldValue
  ) => {
    if(oldValue===0) return "--"
    const percentageChange = ((newValue - oldValue) / oldValue) * 100;
    const roundedChange = Math.round(percentageChange * 10) / 10;
    
    return roundedChange
  }
  
  if (!reportData) return null;
  return (
    <>
    <CoverPage
      {...props}
      summarizeGeographies={summarizeGeographies} 
      priorYearPeriodName={priorYearPeriodName} 
      currentPeriodName={currentPeriodName}
     />
    {statTypes.map(type => {
      
      return <PropertyTypePage 
      type={type} 
      {...props}
      summarizeGeographies={summarizeGeographies} 
      priorYearPeriodName={priorYearPeriodName} 
      currentPeriodName={currentPeriodName}
      />
      
    })}
    </>
  )
    

};

export default BlendedLayout;